export default __webpack_public_path__ + "static/media/logout.a08352b9.png";